import styled from 'styled-components';

export const Container = styled.div`
  padding: 30px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0 0 6px 0;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  margin: 0;
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const Badge = styled.span`
  padding: 2px 8px;
  margin-left: 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) =>
    props.active
      ? 'rgba(255, 255, 255, 0.2)'
      : props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.1)'
      : 'rgba(0, 0, 0, 0.1)'};
`;

export const ContentWrapper = styled.div`
  /* Content area */
`;

export const StatsContainer = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
`;

export const MiniStatCard = styled.div`
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.04)'
      : 'rgba(0, 0, 0, 0.02)'};
  border: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.06)'};
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 100px;

  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
  }
`;

export const MiniStatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 4px;
  color: ${(props) => props.color || '#ffffff'};
`;

export const MiniStatLabel = styled.div`
  font-size: 11px;
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const PageTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0 0 4px 0;
`;

export const PageDescription = styled.p`
  font-size: 14px;
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  margin: 0;
`;

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 12px;
  margin-bottom: 20px;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 200px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px 10px 40px;
  border: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 8px;
  background: ${(props) => props.theme?.background || '#ffffff'};
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #fa4616;
    box-shadow: 0 0 0 3px rgba(250, 70, 22, 0.1);
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  pointer-events: none;
`;

export const Select = styled.select`
  padding: 10px 36px 10px 12px;
  border: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 8px;
  background: ${(props) => props.theme?.background || '#ffffff'};
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  font-size: 14px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;

  &:focus {
    outline: none;
    border-color: #fa4616;
    box-shadow: 0 0 0 3px rgba(250, 70, 22, 0.1);
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;

  ${(props) => {
    if (props.variant === 'published') {
      return 'background: #d1fae5; color: #065f46;';
    }
    if (props.variant === 'draft') {
      return `background: ${
        props.theme?.name === 'dark'
          ? 'rgba(255, 255, 255, 0.1)'
          : 'rgba(0, 0, 0, 0.1)'
      }; color: ${props.theme?.name === 'dark' ? '#94A3B8' : '#64748B'};`;
    }
    if (props.variant === 'discover') {
      return 'background: #e9d5ff; color: #6b21a8;';
    }
    if (props.variant === 'howto') {
      return 'background: #dbeafe; color: #1e40af;';
    }
    if (props.variant === 'new') {
      return 'background: #FA4616; color: white;';
    }
    if (props.variant === 'featured') {
      return 'background: #FA4616; color: white;';
    }
    return '';
  }}
`;

export const ActionButton = styled.button`
  padding: 8px;
  border: none;
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(0, 0, 0, 0.05)'};
  color: ${(props) =>
    props.danger
      ? '#ef4444'
      : props.theme?.name === 'dark'
      ? '#94A3B8'
      : '#64748B'};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${(props) =>
      props.danger
        ? 'rgba(239, 68, 68, 0.1)'
        : props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.08)'};
    color: ${(props) =>
      props.danger
        ? '#dc2626'
        : props.theme?.name === 'dark'
        ? '#ffffff'
        : '#0F172A'};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const TopicCard = styled.div`
  padding: 20px;
  background: ${(props) =>
    props.theme?.name === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 12px;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const TopicHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const TopicIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(250, 70, 22, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fa4616;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const TopicTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0 0 4px 0;
`;

export const TopicDescription = styled.p`
  font-size: 14px;
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  margin: 0 0 12px 0;
`;

export const TopicFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
`;

export const ResultsCount = styled.div`
  margin-top: 16px;
  font-size: 14px;
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
`;
